import { render } from "./MaterialSettings.vue?vue&type=template&id=6a817122&scoped=true"
import script from "./MaterialSettings.vue?vue&type=script&lang=js"
export * from "./MaterialSettings.vue?vue&type=script&lang=js"

import "./MaterialSettings.vue?vue&type=style&index=0&id=6a817122&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a817122"]])

export default __exports__